module.exports = __webpack_public_path__ + "img/zixun_3@2x.8d1c5054.png";